module.exports = __webpack_public_path__ + "static/img/sdab_zyms_two.b432559.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdab_zyms_two.png
// module id = Sosv
// module chunks = 21